import { render, staticRenderFns } from "./VGrid.vue?vue&type=template&id=5d20f2dc&"
import script from "./VGrid.vue?vue&type=script&lang=js&"
export * from "./VGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d20f2dc')) {
      api.createRecord('5d20f2dc', component.options)
    } else {
      api.reload('5d20f2dc', component.options)
    }
    module.hot.accept("./VGrid.vue?vue&type=template&id=5d20f2dc&", function () {
      api.rerender('5d20f2dc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VGrid.vue"
export default component.exports